<template>
  <b-modal
    id="payout-states"
    title="Payout States"
    hide-footer
    @shown="fetchPayoutStates"
    @hidden="hiddenModal"
  >
    <b-spinner
      v-if="loading"
      variant="primary"
    />
    <div
      class="d-flex align-items-center"
    >
      <div
        v-for="(state, ix) in states"
        :key="ix"
        class="mr-1"
      >
        <div>{{ snakeCaseToCamelCase(state.state) }} <span v-if="ix != states.length -1">=></span> </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import {
  BSpinner,
  BModal,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import axiosIns from '@/libs/axios'
import snakeCaseToCamelCase from '@/utils/snake-case-to-camcel-caase'

export default {
  components: {
    BModal,
    BSpinner,
  },
  props: {
    payoutId: {
      type: String,
      default: undefined,
    },
  },
  setup(props) {
    const states = ref([])

    const loading = ref(false)
    const fetchPayoutStates = async () => {
      loading.value = true
      const res = await axiosIns.get(`/${props.payoutId}/states`)
      states.value = res.data.data.reverse()
      loading.value = false
    }

    const hiddenModal = () => {
      states.value = []
    }

    return {
      loading,
      fetchPayoutStates,
      snakeCaseToCamelCase,
      states,
      hiddenModal,
    }
  },
}
</script>
